<template>
  <div>
    <vm-table
        ref="vmTable"
        height="80vh"
        :filter.sync="filter"
        module="basic"
        url="applications/todo/my">
      <el-table-column prop="sequID" label="主键"/>
      <el-table-column prop="billNO" label="单据编号">
        <template slot-scope="scope">
          <a @click="gotoApprove(scope.row)">{{scope.row.billNO}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="descrpt" label="节点名称"/>
      <el-table-column prop="createdTime" label="流程到达时间"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";

  export default {
    name: "TodoSalesOrder",
    components: {VmTable},
    data() {
      return {
        filter: {
          billType: 1,
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      gotoApprove(row) {
        this.$router.push({
          path: "/approval",
          query: {
            billType: 1,
            billId: row.billID,
            sequId: row.sequID,
            $tabName: "审批_" + row.billNO,
          },
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
